import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../../_constant/constants';
import { TaskAddTaskDto } from '../../_dto/_task/TaskAddTaskDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiAddTask = async (taskAddTaskDto: TaskAddTaskDto) => {
  const params: IApiParams = {
    url: '/task/addTask.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME), 
    },
  };
  return getApi(params, 'POST', taskAddTaskDto);
};